import { useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { ASK_PSD_API_BASE_URL } from '@config/envConfig';

const WIDGET_PROJECT_ID = 'PSD';
const WIDGET_HOST = '';

export default function ChatWidgetMount() {
  const { oktaAuth } = useOktaAuth();

  useEffect(() => {
    const config = {
      apiBaseUrl: ASK_PSD_API_BASE_URL,
      projectId: WIDGET_PROJECT_ID,
      authToken: oktaAuth?.getAccessToken(),
    };

    if (window.PsdChatWidget) {
      window.PsdChatWidget.mount(config);
      return undefined;
    }

    if (document.querySelector('script[data-psd-chat-widget]')) return undefined;

    const script = document.createElement('script');
    script.src = `${WIDGET_HOST}/widget.js`;
    script.dataset.psdChatWidget = 'true';
    script.onload = () => window.PsdChatWidget.mount(config);
    document.body.appendChild(script);

    return undefined;
  }, [oktaAuth]);

  return null;
}
